/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { FormGroup } from '@angular/forms';
import { Directive } from "@angular/core";
import { FormUtils } from "@irian-ro/util-forms";

@Directive()
export abstract class BaseForm<T> {

  model: T | undefined = undefined;
  form: FormGroup | undefined = undefined;

  protected constructor() {
    this.form = this.createForm();
  }

  protected abstract createForm(): FormGroup;

  protected getFormValue(): T {
    return this.form?.getRawValue() as T;
  }

  protected updateFormValue(newValue: T = this.model as T, options?: { onlySelf?: boolean, emitEvent?: boolean }) {
    this.form?.patchValue(newValue, options);
    this.form?.updateValueAndValidity();
    FormUtils.markAllAsTouched(this.form);
  }
}
